import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { ROUTER_CONFIG_DROPDOWN } from "../../DropdownConstants.js";
import { GET_ALL_CONFIGS, SET_CURRENT_CONFIG } from "../../appConstants.js";
import "../../components/Headers/Header.css";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DeleteAlert from "../DeleteAlert";
import "../HomeHeader.css";
import ConfigureModal from "../Modal/ConfigureModal.jsx";
import "../Tables/Table.css";
import LoaderComponent from "./LoaderComponent/LoaderComponent.js";

const Pacsconfig = () => {
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(true);
  const [sortby, setsortby] = useState("");
  const [searchkeyword, setSearchKeyword] = useState({});
  const [asc, setAsc] = useState(true);
  const [count, setCount] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [add, setAdd] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteID, setDeleteID] = useState(0);
  const [searchWord, setSearchWord] = useState("");
  const [deleteUpdate, setdeleteUpdate] = useState(false);

  const navigate = useNavigate();
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      fontSize: 15,
    },
  }));

  function handleSearch(e) {
    const filterobj = { asc: asc, sort_by: sortby, keyword: e.target.value };
    setSearchWord(e.target.value);
    setCount(1);
    setSearchKeyword(filterobj);
  }

  const handlechange = () => {
    const filterobj = { asc: asc, sort_by: sortby, keyword: searchWord };
    setSearchKeyword(filterobj);
  };

  const handleOrder = () => {
    if (sortby !== "") {
      const filterobj = { asc: !asc, sort_by: sortby, keyword: searchWord };
      setSearchKeyword(filterobj);
      setAsc((asc) => !asc);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };

  const handleclick = () => {
    setAdd(true);
  };

  const handleclose = () => {
    setAdd(false);
    setEditData({});
  };

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
  };

  const handleEdit = (data) => {
    setAdd(true);
    setEditData(data);
  };

  const handleViewWorkflow = (id) => {
    navigate(`/flow/${id}`);
  };

  const handleconfig = (data, e) => {
    const sendData = async () => {
      let filterobj = { id: data, toggle: e.target.checked };
      setSearchKeyword(filterobj);
      try {
        const response = await axiosInstance.post(
          `${SET_CURRENT_CONFIG}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success === true) {
          toast.success(`success: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
        if (response.data.success === false) {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    sendData();
  };

  useEffect(() => {
    handlechange();
  }, [sortby]);

  useEffect(() => {
    const filterobj = searchkeyword;
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_ALL_CONFIGS}?page=${count}&size=10`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setData(response.data.items);
        setTotalPages(response.data.pages);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };
    fetchData();
  }, [searchkeyword, count, update, deleteUpdate]);

  return (
    <div>
      <div className="header">
        <h6 className="header-text">ROUTER CONFIGURATION</h6>
        <div className="d-flex justify-content-between mb-5">
          <div className="d-flex justify-content-start gap-3">
            <div>
              <h6
                style={{
                  fontFamily: "Montserrat",
                  color: "#0fc4a0",
                  fontSize: "14px",
                }}
              >
                Sort By
                <span style={{ color: "black" }}>&nbsp;||&nbsp;</span>
                <span
                  style={{ color: "rgb(249, 215, 161)", cursor: "pointer" }}
                >
                  <span
                    onClick={handleOrder}
                    style={{ fontFamily: "Montserrat" }}
                  >
                    {asc ? "Desc" : "Asc"}
                  </span>
                  {asc ? (
                    <i className="fa fa-sort-amount-asc"></i>
                  ) : (
                    <i className="fa fa-sort-amount-desc"></i>
                  )}
                </span>
              </h6>

              <Select
                displayEmpty
                placeholder="Sort By"
                className="sort"
                value={sortby || ""}
                name="Sort"
                onChange={(e) => {
                  setsortby(e.target.value);
                }}
                style={{ color: "white", height: "39px" }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      backgroundColor: "#121c1b",
                      color: "white",
                      borderRadius: "5px",
                      border: "1px solid #0fc4a0",
                    },
                  },
                }}
              >
                <MenuItem value="" style={{ fontSize: "14px" }}>
                  Select
                </MenuItem>
                {data &&
                  data.length > 0 &&
                  ROUTER_CONFIG_DROPDOWN.map((option) => (
                    <MenuItem
                      key={option.label}
                      value={option.value}
                      style={{ fontSize: "14px" }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
              </Select>
            </div>
            <div className="mr-4 d-flex flex-column justify-content-between">
              <h6
                style={{
                  fontFamily: "Montserrat",
                  color: "#0fc4a0",
                  fontSize: "14px",
                }}
              >
                Search
              </h6>
              <input
                style={{ height: "39px" }}
                type="search"
                placeholder="Search here"
                className="search"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch(e);
                  }
                }}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn mr-4 shadow btn-dataset"
            style={{
              height: 39,
              width: 200,
              color: "black",
              backgroundColor: "#0FC4A0",
              position: "relative",
              top: 25,
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily: "Montserrat",
            }}
            onClick={handleclick}
          >
            ADD
          </button>
        </div>
      </div>

      {loader ? (
        <div>
          <div className="d-flex flex-column">
            <div>
              <div className="d-flex flex-column">
                <div>
                  <table className="styled-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>PACS Config</th>
                        <th>Filter</th>
                        <th>Platform</th>
                        <th>Anon Protocol</th>
                        <th>Push Back Results</th>
                        <th>Select Config</th>
                        <th>Actions</th>
                        {/* <th>View WorkFlow</th> */}
                      </tr>
                    </thead>
                    {data && data.length > 0 ? (
                      <tbody>
                        {data.map((data, index) => (
                          <tr key={index} className="styled-table">
                            <td>{data.config_name}</td>
                            <td>{data.pacs_config_data.name}</td>
                            <td>
                              {data.filter_data !== null
                                ? data.filter_data.name
                                : "None"}
                            </td>
                            <td>{data.platform_data.name}</td>
                            <td>{data.anon_protocol_data.name}</td>
                            <td>
                              {data.push_back_results === 1
                                ? "Automatic"
                                : data.push_back_results === 2
                                ? "Manual"
                                : "Do Not Push"}
                            </td>
                            <td>
                              <label className="main_checkbox">
                                <input
                                  type="checkbox"
                                  id="myCheckbox"
                                  checked={data.current_config}
                                  onClick={(e) => handleconfig(data.id, e)}
                                />
                                <div className="carpl_checkbox" />
                              </label>
                            </td>
                            <td>
                              <BootstrapTooltip title="Delete">
                                <IconButton>
                                  <DeleteIcon
                                    onClick={() => handleDelete(data.id)}
                                    style={{
                                      color: "white",
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </BootstrapTooltip>
                              {deleteAlert && (
                                <DeleteAlert
                                  type="RouterConfigTable"
                                  id={deleteID}
                                  deleteAlert={deleteAlert}
                                  setDeleteAlert={setDeleteAlert}
                                  setdeleteUpdate={setdeleteUpdate}
                                />
                              )}
                              <BootstrapTooltip title="Edit">
                                <IconButton>
                                  <ModeEditIcon
                                    onClick={() => handleEdit(data)}
                                    style={{
                                      color: "white",
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </BootstrapTooltip>
                            </td>
                            {/* <td>
                              <i
                                className="fa fa-eye"
                                onClick={() => handleViewWorkflow(data.id)}
                              ></i>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tr>
                        <td
                          colSpan="12"
                          className="text-center font-weight-bold"
                        >
                          No Records Found
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
              </div>
              {data && data.length > 0 ? (
                <div className="d-flex justify-content-end pb-5 pt-2">
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    forcePage={count && count - 1}
                    onPageChange={(e) => handlePageChange(e.selected)}
                    containerClassName="pagination"
                    subContainerClassName="pages pagination"
                    activeClassName="active"
                    previousLinkClassName="pagination-link"
                    nextLinkClassName="pagination-link"
                    breakLinkClassName="pagination-link"
                    pageLinkClassName="pagination-link"
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ margin: "10vw 48vw" }}
        >
          <div>
            <LoaderComponent />
          </div>
        </div>
      )}
      {add && (
        <ConfigureModal
          handleClose={handleclose}
          ModalState={add}
          setUpdate={setUpdate}
          editData={editData}
        />
      )}
    </div>
  );
};

export default Pacsconfig;
